import React from "react";
import EmailSettingTable from "./EmailSettingTable";
import { useDispatch, useSelector } from "react-redux";
import { showEmailSetting } from "../../../redux/actions";
import { responseSetting } from "../../../redux/reducers";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";

export default function EmailSetting() {
  const dispatch = useDispatch();
  const { emailSetting } = useSelector(responseSetting);

  const { user } = useAuth();
  const history = useHistory();

  React.useEffect(() => {
    if (user) {
      if (user.Queryable !== "queryable_special@123") {
        history.push("/home");
        return;
      }
    }
  }, [history, user]);

  React.useEffect(() => {
    dispatch(showEmailSetting());
  }, [dispatch]);

  return (
    <>
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>EmailSetting</div>
        </div>
        <div className={"breadcrumb-right"}>
          <span className={"breadcrumb-item active"}>EmailSetting</span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-body"}>
          <EmailSettingTable dataSource={emailSetting} />
        </div>
      </div>
    </>
  );
}
